import { render, staticRenderFns } from "./SLButton.vue?vue&type=template&id=e4c8b3ee&scoped=true&"
import script from "./SLButton.vue?vue&type=script&lang=js&"
export * from "./SLButton.vue?vue&type=script&lang=js&"
import style0 from "./SLButton.vue?vue&type=style&index=0&id=e4c8b3ee&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4c8b3ee",
  null
  
)

export default component.exports